export const SET_FORM_MODE = "SET_FORM_MODE";
export function action_updateFormMode(mode) {
	return { type: SET_FORM_MODE, payload: mode };
}

export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export function action_updateFirstLoad(flag, type) {
	return { type: SET_FIRST_LOAD, payload: { flag, type }};
}

export const SET_EDP_PREPARE_ERROR_VALIDATIONS = "SET_EDP_PREPARE_ERROR_VALIDATIONS";
export function action_updateEdPPrepareErrorValidations(l_validations) {
	return { type: SET_EDP_PREPARE_ERROR_VALIDATIONS, payload: l_validations };
}

export const SET_EDP_PREPARE_RESULT = "SET_EDP_PREPARE_RESULT";
export function action_updateEdpPrepareResult(resultObject) {
	return { type: SET_EDP_PREPARE_RESULT, payload: resultObject };
}

export const SET_EDP_PREPARE_PARTIES = "SET_EDP_PREPARE_PARTIES";
export function action_updateEdpPrepareParties(partiesObject) {
	return { type: SET_EDP_PREPARE_PARTIES, payload: partiesObject };
}

export const SET_EDP_PREPARE_DI = "SET_EDP_PREPARE_DI";
export function action_updateEdpPrepareDI(diObject) {
	return { type: SET_EDP_PREPARE_DI, payload: diObject };
}

export const SET_EDP_PREPARE_AMBIENTE = "SET_EDP_PREPARE_AMBIENTE";
export function action_updateEdpPrepareAmbiente(ambiente) {
	return { type: SET_EDP_PREPARE_AMBIENTE, payload: ambiente };
}

export const SET_EDP_PREPARE_HEADER = "SET_EDP_PREPARE_HEADER";
export function action_updateEdpPrepareHeader(header) {
	return { type: SET_EDP_PREPARE_HEADER, payload: header };
}

export const SET_EDP_PREPARE_MANAGE_BUTTONS = "SET_EDP_PREPARE_MANAGE_BUTTONS";
export function action_updateEdPPrepareManageButtons(buttons) {
	return { type: SET_EDP_PREPARE_MANAGE_BUTTONS, payload: buttons };
}






export const SET_EDP_PREPARE_FORCE_GET_RESULT = "SET_EDP_PREPARE_FORCE_GET_RESULT";
export function action_updateEdPPrepareForceGetResult(flag) {
	return { type: SET_EDP_PREPARE_FORCE_GET_RESULT, payload: flag };
}
export const SET_EDP_PREPARE_FORCE_GET_PARTIES = "SET_EDP_PREPARE_FORCE_GET_PARTIES";
export function action_updateEdPPrepareForceGetParties(flag) {
	return { type: SET_EDP_PREPARE_FORCE_GET_PARTIES, payload: flag };
}
export const SET_EDP_PREPARE_FORCE_GET_AMBIENTE = "SET_EDP_PREPARE_FORCE_GET_AMBIENTE";
export function action_updateEdPPrepareForceGetAmbiente(flag) {
	return { type: SET_EDP_PREPARE_FORCE_GET_AMBIENTE, payload: flag };
}
export const SET_EDP_PREPARE_FORCE_GET_HEADER = "SET_EDP_PREPARE_FORCE_GET_HEADER";
export function action_updateEdPPrepareForceGetHeader(flag) {
	return { type: SET_EDP_PREPARE_FORCE_GET_HEADER, payload: flag };
}
export const SET_EDP_PREPARE_FORCE_GET_BUTTONS = "SET_EDP_PREPARE_FORCE_GET_BUTTONS";
export function action_updateEdPPrepareForceGetButtons(flag) {
	return { type: SET_EDP_PREPARE_FORCE_GET_BUTTONS, payload: flag };
}